import { useEffect } from 'react';

import Routing from 'components/common/routing/routing';
import { useAppDispatch } from 'redux/use-hooks';
import { refreshAccount } from 'redux/actions/account';

import 'assets/styles/global.css';

function Main() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(refreshAccount());
  }, []);

  return <Routing />;
}

export default Main;
